import { render, staticRenderFns } from "./DezrannCanvas.vue?vue&type=template&id=1c515b86&scoped=true&shadow"
import script from "./DezrannCanvas.vue?vue&type=script&lang=ts&shadow"
export * from "./DezrannCanvas.vue?vue&type=script&lang=ts&shadow"
function injectStyles (context) {
  
  var style0 = require("./DezrannCanvas.vue?vue&type=style&index=0&id=1c515b86&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1c515b86",
  null
  ,true
)

export default component.exports